export const SET_LANGUAGE = '@@locale/SET_LANGUAGE';
export const SET_LOCALE = '@@locale/SET_LOCALE';
//# sourceMappingURL=types.js.map